module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    key: _vm.componentKey,
    staticClass: "detail-card"
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1px"
    }
  }, [_vm._v("Store Rewards ")]), _vm._v(" "), _vm._l((_vm.sellpoint.reward_settings), function(reward_type) {
    return _c('div', {
      key: reward_type.reward_type_id
    }, [((reward_type.reward_type_id == 2)) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(reward_type.reward_type_name) + " Reward")])]), _vm._v(" "), _c('p', {
      staticClass: "p-tiny-info"
    }, [_vm._v(_vm._s(reward_type.reward_type_descr))]), _vm._v(" "), (reward_type.reward_type_is_set) ? _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('edit' + reward_type.reward_type_name + reward_type.reward_type_id)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward: \n                        "), (reward_type.reward_type_setting.reward_set_amount_type == 'C') ? _c('span', [_vm._v("₦")]) : _vm._e(), (reward_type.reward_type_setting.reward_set_amount) ? _c('span', [_vm._v(_vm._s(reward_type.reward_type_setting.reward_set_amount))]) : _vm._e(), _vm._v(" "), (reward_type.reward_type_setting.reward_set_amount_type == 'P') ? _c('span', [_vm._v("%")]) : _vm._e()])])]) : _c('div', [_c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('set' + reward_type.reward_type_name + reward_type.reward_type_id)
        }
      }
    }, [_vm._v("SET")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "13px"
      }
    }, [_vm._v("No reward set")])]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id] || _vm.menu_tab_inner_view['edit' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('div', [_c('h6', {
      staticClass: "margin-t-40"
    }, [_vm._v("Set a Reward for " + _vm._s(reward_type.reward_type_name) + " ")]), _vm._v(" "), _c('form', {
      staticClass: "sp-form",
      staticStyle: {
        "padding-left": "0"
      }
    }, [_c('label', [_c('b', [_vm._v("Reward Amount: "), (reward_type.reward_type_setting.reward_set_amount) ? _c('span', [_vm._v(_vm._s(reward_type.reward_type_setting.reward_set_amount))]) : _vm._e()]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.business_details.set_reward_type_amount),
        expression: "business_details.set_reward_type_amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "25%",
        "margin-right": "5px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.business_details.set_reward_type_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.business_details.set_reward_type_amount = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_reward_type_amount_type),
        expression: "set_reward_type_amount_type"
      }],
      staticClass: "sp-form-select form-control",
      staticStyle: {
        "width": "45%"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.set_reward_type_amount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("% (percentage)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("₦ (cash)")])])]) : _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward_type.reward_type_setting.reward_set_amount),
        expression: "reward_type.reward_type_setting.reward_set_amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "25%",
        "margin-right": "5px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (reward_type.reward_type_setting.reward_set_amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          reward_type.reward_type_setting.reward_set_amount = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (reward_type.reward_type_setting.reward_set_amount_type),
        expression: "reward_type.reward_type_setting.reward_set_amount_type"
      }],
      staticClass: "sp-form-select form-control",
      staticStyle: {
        "width": "45%"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          reward_type.reward_type_setting.reward_set_amount_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "P"
      }
    }, [_vm._v("% (percentage)")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "C"
      }
    }, [_vm._v("₦ (cash)")])])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.menu_tab_inner_view['set' + reward_type.reward_type_name + reward_type.reward_type_id]) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.postBusinessRewardSettings(reward_type)
        }
      }
    }, [_vm._v("Save")]) : _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.updateBusinessRewardSettings(reward_type.reward_type_setting)
        }
      }
    }, [_vm._v("Save")])]), _vm._v(" "), _c('a', {
      staticClass: "btn sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._v("close")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Turn on Agent Marketing")]), _vm._v(" "), ((_vm.sellpoint.business_is_agents_open == 1)) ? _c('span', {
    staticStyle: {
      "margin-left": "1em",
      "color": "#ff0000"
    }
  }, [_vm._v("ON")]) : _vm._e(), _vm._v(" "), ((_vm.sellpoint.business_is_agents_open == 0)) ? _c('span', {
    staticStyle: {
      "margin-left": "1em",
      "color": "#ff0000"
    }
  }, [_vm._v("OFF")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("You must set a Reward amount before turning on this feature")]), _vm._v(" "), ((_vm.set_reward_commission > 0)) ? _c('div', [_c('div', [((_vm.sellpoint.business_is_agents_open == 1)) ? _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.updateBusinessGeneralSettings(1, {})
      }
    }
  }, [_vm._v("TURN OFF")]) : _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.updateBusinessGeneralSettings(1, {})
      }
    }
  }, [_vm._v("TURN ON")])])]) : _c('div', [_c('div', [((_vm.sellpoint.business_is_agents_open == 1)) ? _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.updateBusinessGeneralSettings(1, {})
      }
    }
  }, [_vm._v("TURN OFF")]) : _c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": true
    }
  }, [_vm._v("TURN ON")])])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a80ac2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account/Sellpoint/Settings/SellpointRewards.vue
// module id = 565
// module chunks = 0